import {React, useEffect, useState} from "react";
import {useQuery} from '@tanstack/react-query'
import {useNavigate, useParams} from "react-router-dom";
import {
    confirmRegistration,
    getChoices,
    getInvoicePDF, getInvoicePDFWithSecret,
    getRegistrationWithSecret,
    getStudentData
} from "../../../api/summer_school";
import {DownloadButton, EditButton, PrimaryButton} from "../../elements/Buttons";
import {toast} from "react-toastify";
import ConfirmationPage from "./ConfirmationPage";

export default function RegistrationConfirm() {

    const {id, secret} = useParams()
    const [data, setData] = useState({})
    const [helperData, setHelperData] = useState({})

    const {data: choices} = useQuery(['summer_school_choices'], getChoices, {refetchInterval: 1000 * 60 * 60 * 24})

    const studentStatusOptions = [
        {value: 'KPI', label: `${data.first_name} ist bereits am Kurpfalz Internat`},
        {value: 'NEU', label: `${data.first_name} wird zum neuen Schuljahr an das Kurpfalz Internat wechseln`},
        {
            value: 'PROSPECT',
            label: `${data.first_name} möchte das Kurpfalz Internat kennenlernen und später entscheiden, ob ein Besuch in Frage kommt`
        },
        {value: 'SUMMER_SCHOOL_ONLY', label: `${data.first_name} möchte nur die Summer School besuchen`}
    ]

    const {data: studentData, isSuccess: studentDataLoaded} = useQuery(
        ['summer_school_student_data', helperData?.student?.id],
        () => getStudentData(helperData?.student?.id),
        {
            enabled: !!helperData.student
        })

    let navigate = useNavigate();

    useEffect(() => {
        loadData()
    }, [id, secret])

    async function loadData() {
        if (!id || !secret) return
        const newData = await getRegistrationWithSecret(id, secret)
        setData(newData)
    }

    const title = "Summer School Anmeldung bestätigen"
    const successMessage = "Anmeldung bestätigt"

    async function onConfirm() {

        try {
            const newData = await confirmRegistration(data)
            setData(newData)
            toast.success(successMessage)

        } catch (e) {
            console.log(e)
            if (e.message !== "Validation failed") { // Don't show API error for validation failures
                toast.error("Fehler beim Speichern. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.")
            }
            throw e
        }
    }

    return (

        <div className="max-w-4xl mx-auto px-4 py-4 sm:px-6 md:px-8">

            <div className="mx-auto grid grid-cols-1 gap-6 md:grid-flow-col-dense md:grid-cols-4">

                <div className="md:col-span-3 md:col-start-1">
                    {/* right column */}
                    <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>

                    {(data.status === 'DRAFT' || data.status === 'PENDING_CHANGES' || data.status === 'PENDING_CONFIRMATION') ? <>
                        <p className="mt-2 mb-1 text-sm text-gray-700">
                            Hiermit bestätige ich die Anmeldung meines Kindes:
                        </p>

                        <div className="flex gap-2">
                            <PrimaryButton onClick={onConfirm} label="Anmeldung bestätigen"></PrimaryButton>
                            <EditButton
                                iconOnly={false}
                                link={`/summer-school/registration/${data.id}/${data.secret}/edit`}
                                label="Anmeldung bearbeiten"
                            />
                        </div>
                    </> :
                        <>
                            <p className="mt-2 mb-1 text-sm text-gray-700">
                                Ihre Anmeldung ist bestätigt. Wenn Sie weitere Änderungen vornehmen möchten,
                                kontaktieren Sie bitte unser Team.
                            </p>
                        </>}


                    {data.invoice_pdf && <div className="mt-12 py-4">
                        <h5 className="mb-2 sm:col-span-6 font-medium text-lg">Rechnung</h5>
                        <DownloadButton
                            apiFunction={() => getInvoicePDFWithSecret(data.id, data.secret)}
                            fileName="Rechnung.pdf"
                            label="Rechnung herunterladen"/>
                    </div>}


                    <div className="mt-12">
                        <h2 className="text-lg font-semibold text-gray-900">Details der Anmeldung</h2>
                        <ConfirmationPage data={data}
                                          choices={choices}
                                          editingAllowed={false}
                                          confirmationScreen={true}
                                          studentStatusOptions={studentStatusOptions}
                                          goToStep={null} />
                    </div>

                </div>

            </div>

        </div>
    )
}
